import { useState } from "react";
import { Document, Page } from "react-pdf";
import './PdfViewer.scss';
//FOR DEPLOY USE FROM CDN!!!! BELOW!!//
//import 'react-pdf/dist/Page/AnnotationLayer.css';
// Text layer for React-PDF.
//import "react-pdf/dist/Page/TextLayer.css";

import { closeAdminPdfView } from "../../../../adminSlice";
import Config from '../../../../../../config/config';



const PdfViewer = (props) => {


//FOR DEPLOY USE FROM CDN!!!! BELOW!!//

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const {dispatch} = props;
  const serverPath = Config.serverPath;
//ON CLICK CLOSE
        const onClickClose = () => {
            dispatch(closeAdminPdfView());

        }


  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () =>
    setPageNumber(pageNumber - 1 <= 1 ? 1 : pageNumber - 1);

  const goToNextPage = () =>
    setPageNumber(pageNumber + 1 >= numPages ? numPages : pageNumber + 1);

const pdfName = props.pdfName;
const pdf_src = pdfName? `${serverPath}/api/pdf/${props.selectedIdNote}/${props.pdfName}`: null; 

  return (
    <div className="PdfViewer">
      <div className="navigate">
        <button className="exit" onClick={onClickClose}></button>
        <button className="prev-next" onClick={goToPrevPage}>Prev</button>
        <button className="prev-next" onClick={goToNextPage}>Next</button>
        <p className="pages">
          Page {pageNumber} of {numPages}
        </p>
      </div>

      <Document
        file={pdf_src}// Path to your PDF file.
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page pageNumber={pageNumber} />
      </Document>
    </div>
  );
  
};

export default PdfViewer;